interface BookmarkIconProps {
  isSaved: boolean;
  className?: string;
  onAnimationEnd?: () => void;
}

function BookmarkIcon({
  isSaved,
  className,
  onAnimationEnd,
}: BookmarkIconProps) {
  return isSaved ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
      aria-hidden="true"
      className={className}
      onAnimationEnd={onAnimationEnd}
    >
      <path
        d="M12 0H1.5C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5V18C6.65975e-05 18.1338 0.0359509 18.2652 0.103929 18.3805C0.171907 18.4958 0.269503 18.5908 0.386587 18.6557C0.503672 18.7206 0.635979 18.7529 0.76978 18.7494C0.90358 18.7458 1.034 18.7066 1.1475 18.6356L6.75 15.1341L12.3534 18.6356C12.4669 18.7063 12.5972 18.7454 12.7309 18.7488C12.8646 18.7522 12.9967 18.7198 13.1136 18.655C13.2306 18.5902 13.3281 18.4953 13.396 18.3801C13.4639 18.2649 13.4998 18.1337 13.5 18V1.5C13.5 1.10218 13.342 0.720644 13.0607 0.43934C12.7794 0.158035 12.3978 0 12 0Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
      aria-hidden="true"
      className={className}
      onAnimationEnd={onAnimationEnd}
    >
      <path
        d="M12.375 0H1.875C1.37772 0 0.900806 0.197544 0.549175 0.549175C0.197544 0.900805 6.34204e-08 1.37772 6.34204e-08 1.875V18.375C-6.73674e-05 18.5758 0.0536374 18.7731 0.155537 18.9461C0.257437 19.1192 0.403815 19.2619 0.579471 19.3593C0.755127 19.4567 0.953654 19.5052 1.15444 19.5C1.35522 19.4947 1.55093 19.4358 1.72125 19.3294L7.12406 15.9544L12.5287 19.3294C12.6991 19.4358 12.8948 19.4947 13.0956 19.5C13.2963 19.5052 13.4949 19.4567 13.6705 19.3593C13.8462 19.2619 13.9926 19.1192 14.0945 18.9461C14.1964 18.7731 14.2501 18.5758 14.25 18.375V1.875C14.25 1.37772 14.0525 0.900805 13.7008 0.549175C13.3492 0.197544 12.8723 0 12.375 0ZM12 16.3453L7.72031 13.6706C7.54151 13.5589 7.33491 13.4996 7.12406 13.4996C6.91321 13.4996 6.70661 13.5589 6.52781 13.6706L2.25 16.3453V2.25H12V16.3453Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default BookmarkIcon;
